module.exports = __webpack_public_path__ + "6924793491eb448b07ed2826f56fa1a9.png";